/**
 * Created by Arif Topcu in 2018.
 * 3.0.0 breaking changes:
 *  - Removed persistency feature. This should be abstracted at a higher level at an HOC
 *
 * 2.0.0 breaking change:
 *  - Use value prop instead of checked.
 */
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import styles from './ReactSwitch.module.css';

const Switch = ({value: checked, raised, size, disabled, onChange, label, className, enablePersistence, persistenceKey,
                  persistenceModule}) => {
  const rootClassName = useMemo(() => {
    const classNames = [styles.root];
    if (raised) {
      classNames.push(styles.rootRaised);
    }
    if (className) {
      classNames.push(className);
    }
    return classNames.join(' ');
  }, [raised, className]);
  const switchClassName = useMemo(() => {
    return [styles.switch, styles[`switchSize${size}`]].join(' ');
  }, [size]);
  const onClick = useMemo(() => {
    if (disabled) return () => {
    }; //noop
    else return () => {
      const newChecked = !checked;
      onChange(newChecked);
      if (enablePersistence && persistenceModule) {
        persistenceModule.persistSetting(persistenceKey, newChecked);
      }
    };
  }, [checked, disabled, onChange, enablePersistence, persistenceKey, persistenceModule]);

  const sliderClass = useMemo(() => {
    const classNames = [styles.slider, styles.round, styles[`sliderSize${size}`]];
    if (checked) {
      classNames.push(styles.checked);
    }
    if (disabled) {
      classNames.push(styles.disabled);
    }
    return classNames.join(' ');
  }, [checked, disabled, size]);

  const labelClass = useMemo(() => {
    const classNames = [styles.label, styles[`labelSize${size}`]];
    if (checked) {
      classNames.push(styles.labelChecked);
    }
    return classNames.join(' ');
  }, [checked, size]);

  return (
    <div className={rootClassName}>
      <div className={switchClassName} onClick={onClick}>
        <div className={sliderClass}/>
      </div>
      {label && (
        <div className={labelClass}>
          {label}
        </div>
      )}
    </div>
  )
};

Switch.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  raised: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['M', 'XS']),
  enablePersistence: PropTypes.bool,
  persistenceKey: PropTypes.string,
  persistenceModule: PropTypes.object,
};

Switch.defaultProps = {
  size: 'M',
  raised: false,
};

export default Switch;
